export type ProfileSettings = {
  displayName: string;
  avatarBase64: string | null;
  role: 'admin' | 'technician';
};

export type CredentialSettings = {
  email: string;
  googleConnected: boolean;
  googleEmail: string | null;
  hasPassword: boolean;
};

export type SessionInfo = {
  label: string;
  browser: string;
  os: string;
  lastActive: string;
};

export type EmailAlertsSettings = {
  inspectionAssigned: boolean;
  inspectionCompleted: boolean;
  deficiencyFlagged: boolean;
  workOrderCreated: boolean;
  workOrderStatusChanged: boolean;
  quoteSent: boolean;
  invoiceSent: boolean;
  invoiceOverdue: boolean;
};

export type InspectionReminderSettings = {
  daysBefore: number;
  recipient: 'admin' | 'technician' | 'both';
  includeSummary: boolean;
};

export type NotificationSettingsState = {
  emailAlerts: EmailAlertsSettings;
  inspectionReminder: InspectionReminderSettings;
};

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettingsState = {
  emailAlerts: {
    inspectionAssigned: true,
    inspectionCompleted: true,
    deficiencyFlagged: true,
    workOrderCreated: false,
    workOrderStatusChanged: false,
    quoteSent: true,
    invoiceSent: true,
    invoiceOverdue: true
  },
  inspectionReminder: {
    daysBefore: 7,
    recipient: 'admin',
    includeSummary: true
  }
};

export type SaveButtonState = 'idle' | 'saving' | 'saved';
